import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { Login } from "@/features/login";
import { useAuth } from "@/features/login/context/AuthContext";

function IndexPage() {
    const { accessToken } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (accessToken) {
            navigate({ to: "/agent/policy" });
        }
    }, [accessToken, navigate]);

    if (accessToken) {
        return null; // or a loading spinner
    }

    return <Login />;
}

export const Route = createFileRoute("/")({
    component: IndexPage,
});
